<template>
<defaultLayout section="matter-article">
  <template slot-scope="slotProps">
    <div class="matter-article-container">
      <article-header
        v-if="hasFeaturedImage"
        :data="featuredImage"
      />
      <article-body
        :data="data"
      />
      <social-media-sharing
        :data="data" :href="href"
      />
    </div>
  </template>
</defaultLayout>
</template>

<script>
// Libs
import axios from 'axios';

// Components
import defaultLayout from '@/layouts/default';
import ArticleHeader from '@/components/matter-article/ArticleHeader';
import ArticleBody from '@/components/matter-article/ArticleBody';
import SocialMediaSharing from '@/modules/matter/SocialMediaSharing';

// Constants
import { companyName } from '@/data/snippets/companyInfo';

// Utils
import { getResponsiveUrl } from '@/utils/image-utils';

export default {

  name: 'MatterArticle',

  metaInfo() {
    return {
      title: this.articleTitle || 'Particle Design',
      meta: [
        {
          property: 'og:type',
          content: 'article',
        },
        {
          name: 'description',
          property: 'og:description',
          content: this.articleDescription,
        },
        {
          name: 'image',
          property: 'og:image',
          content: this.imageUrl,
        },
        {
          property: 'og:site_name',
          content: this.companyName,
        },
        {
          name: 'title',
          property: 'og:title',
          content: this.articleTitle,
        },
        {
          property: 'og:url',
          content: this.href,
        },

        // Twitter Specific
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:description',
          content: this.articleTitle,
        },
        {
          name: 'twitter:image',
          content: this.imageUrl,
        },
        {
          name: 'twitter:title',
          content: this.articleTitle,
        },
        {
          name: 'twitter:url',
          content: this.href,
        },
      ],
    };
  },

  components: {
    defaultLayout,
    ArticleBody,
    ArticleHeader,
    SocialMediaSharing,
  },

  props: ['href', 'origin', 'path', 'slug'],

  data() {
    return {
      // this will be the json structure of the article
      data: {},
      companyName,
    };
  },

  computed: {

    articleTitle() {
      const { data } = this;
      return data.title || 'Particle Design';
    },

    articleDescription() {
      const { data } = this;
      return data.standfirst || '';
    },

    featuredImage() {
      const { data } = this;
      return data.featuredImage;
    },

    hasFeaturedImage() {
      const { featuredImage } = this;
      return (featuredImage !== undefined);
    },

    imageUrl() {
      const { hasFeaturedImage, featuredImage, origin } = this;

      let result = '';
      if (hasFeaturedImage) {
        const { imageSrc: src } = featuredImage;
        const rUrl = getResponsiveUrl(src, 1200);
        result = [origin, rUrl].join('');
      }
      return result;
    },
  },

  created() {
    const url = `/static/content/matter/${this.slug}.json`;
    axios({ method: 'get', url })
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          this.data = data;
        } else {
          // do something
        }
      })
      .catch((e) => {
        // TODO: send out error somewhere
        // until then...
        /* eslint-disable no-console */
        console.error(`ERROR retrieving '${url}'`);
        console.error(e);
      });
  },
};
</script>



<style lang="scss">
@import '../styles/_mixins.scss';
@import '../styles/_typography.scss';
@import '../styles/_mixins.scss';

.section-matter-article {

  /*
    this section handles "extended-desktop" mode
    it should be on all "core" pages
  */
  main {
    width: 100%;
    display: grid;

    // media query props
    grid-template-columns: 0 100vw 0;

    @include ngMq($layout--max-content-width, up) {
      grid-template-columns: 1fr $layout--max-content-width 1fr;
    }

    .matter-article-container {
      grid-column: 2 / span 1;
    }
  }

  footer {
    // & > [data-module],
    & > .matter-featured {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      grid-gap: rem(24px);
      padding: 0 rem(26px);

      @include ngMq($nbp--tablet, up) {
        grid-template-columns: repeat(12, 1fr);
        grid-gap: rem(26px);
        padding: 0 rem(42px);
      }

      @include ngMq($nbp--desktop, up) {
        grid-gap: rem(37px);
        padding: 0 rem(138px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/MatterArticle.vue